import React, { useContext, useEffect, useState } from "react";
import { ECLLoader } from "../../../index";
import {
   sourceOneRestURL,
   sourceOneRESTFetchConfig,
   getECLToken,
} from "../../../../utilities/requests";
import { ToastContext } from "../../../../utilities/contexts";

export default function ECLImageViz(props) {
   const [imgHtml, setImgHtml] = useState(null);
   const addToast = useContext(ToastContext);
   const [error, setError] = useState(null);
   const [loading, setLoading] = useState(true);

   useEffect(() => {
      //Return the token to do a custom fetch, where instead of returning as JSON, turn into a file blob and finally pass
      //image data to the img tag.
      getECLToken().then((accessToken) => {
         fetch(sourceOneRestURL, {
            ...sourceOneRESTFetchConfig(accessToken),
            body: JSON.stringify({
               query_type: "file_data",
               object: props.object_id,
               project_id: "3c695bbe-c223-748f-68a6-a6ffa67d0126",
            }),
         })
            .then((res) => {
               return res.arrayBuffer(); //Take fetch response and turn it into an array buffer
            })
            .then((buffer) => {
               let blob = new Blob([buffer]);
               let image = window.URL.createObjectURL(blob);
               setImgHtml(image);
               setLoading(false);
            })
            .catch((error) => {
               setError("There was an error retreiving an image");
               console.error(error);
               addToast("There was an error retreiving an image.", "error");
            });
      });
   }, []);

   if (loading || error || !imgHtml) {
      return <ECLLoader message={error} />;
   }

   return (
      <img src={imgHtml} className="rich-image-viz" alt="Image Visualization" />
   );
}
